import { ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import { getConsent, setConsent as persistConsent, type ConsentState } from "../../lib/storage";
import { useInstrumentation } from "../../hooks/useInstrumentation";
import { ConsentContext } from "./context";

export function ConsentProvider({ children }: { children: ReactNode }) {
  const [consent, setConsent] = useState<ConsentState>(() => getConsent());
  const instrumentation = useInstrumentation();

  useEffect(() => {
    if (consent === "accepted") {
      instrumentation.optIn();
    } else if (consent === "rejected") {
      instrumentation.optOut();
    }
  }, [consent, instrumentation]);

  const accept = useCallback(() => {
    persistConsent(true);
    setConsent("accepted");
  }, []);

  const reject = useCallback(() => {
    persistConsent(false);
    setConsent("rejected");
  }, []);

  const value = useMemo(() => ({ consent, accept, reject }), [consent, accept, reject]);

  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
}
